import Basic from '@/layouts/Basic';

const router = [
    {
        path: '/register',
        component: Basic,
        meta: { onlyUnregistred: true },
        children: [
            {
                path: '',
                name: 'register',
                component: () => import('@/views/register'),
            },
        ],
    },
];

export default router;
